export default "__VITE_ASSET__f05c7dc3__"